var replaceWhitespace = ((value, replace)=>value.replace(/\s+/g, replace)
);

export { replaceWhitespace as default };
//# sourceMappingURL=replace-whitespace.js.map
